module.exports = __webpack_public_path__ + "img/stock2.69412aee.png";